// extracted by mini-css-extract-plugin
export default {"tooltip":"sankey-chart-component_tooltip__6KqY1"};